import { createContext, useContext } from "react";

// Whether the current form surface reveals read-only fields that are hidden
// in the back-office (ex: FranceConnect pivot identity data). Defaults to
// false so hidden fields stay hidden everywhere (sign-up, post sign-up,
// contribution forms) except on surfaces explicitly opting in, like the
// profile edition page where the user reviews their full profile.
export const RevealHiddenReadOnlyFieldsContext = createContext(false);

export const useRevealHiddenReadOnlyFields = () => {
  return useContext(RevealHiddenReadOnlyFieldsContext);
};
